import React, { useCallback } from 'react'
import { ActionChip, Grid } from '@fs/zion-ui'
import ErrorBoundary from '@fs/zion-error-boundary'

export default function ContributorActionChips({
  contributors,
  changeOptions,
  selectedContributorMap,
  setSelectedContributorMap,
}) {
  const onChipClick = useCallback(
    ({ cisId }) => {
      setSelectedContributorMap((prevSelectedContributorMap) => {
        const currentIsSelected = prevSelectedContributorMap[cisId]
        const newIsSelected = !currentIsSelected
        changeOptions({ cisId: newIsSelected ? cisId : undefined })
        return { [cisId]: newIsSelected }
      })
    },
    [changeOptions, setSelectedContributorMap]
  )

  return (
    <Grid guttersY="nano">
      {/* contactName can sometimes be undefined. */}
      {contributors?.map(({ cisId, contactName }) => (
        <ErrorBoundary key={cisId}>
          <ActionChip
            data-testid={`${contactName}-filter-chip`}
            columns={12}
            onClick={() => onChipClick({ cisId })}
            avatarProps={{ monogram: contactName?.[0] }}
            selected={Boolean(selectedContributorMap[cisId])}
            label={contactName}
          />
        </ErrorBoundary>
      ))}
    </Grid>
  )
}
